'use strict';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './cart.routes';
import angularFilter from 'angular-filter';
import CartItemList from '../../components/cart-item-list';
import AlternateSizesDialog from '../../components/alternate-sizes-dialog';
import CartSummaryDialog from '../../components/cart-summary-dialog';
import CheckoutProcessTabs from '../../components/checkout-process-tabs';
import ExpressCheckout from '../../components/express-checkout';
import ItemReviewCard from '../../components/item-review-card';
import CartSummary from '../../components/cart-summary';
import ShippingOptions from '../../components/shipping-options';
import PromoBannerSideCol from '../../components/promo-banner-side-col';
import CoOpBanner from '../../components/co-op-banner';
import OrderSummaryList from '../../components/order-summary-list';
import AkrisOrderSummaryList from '../../components/order-summary-list/akris-order-summary-list';
import PageLevelAlertMessing from '../../components/page-level-alert-messaging';
import PaymentCreditCardForm from '../../components/payment-credit-card';
import PaymentCreditCardFrameForm from '../../components/payment-credit-card-frame';
import CsaPanel from '../../components/csa-panel';
import QuantityAdjustment from '../../components/quantity-adjustment';
import ReviewOrder from './checkout/review-order';
import ThankYou from './checkout/thankyou';
import Payment from './checkout/payment';
import CartService from './cart.service';
import { CartEvents } from './cart-events';
export default angular.module('eeComUiApp.cart', [
    uiRouter,
    AlternateSizesDialog,
    CartItemList,
    CartSummaryDialog,
    CheckoutProcessTabs,
    ExpressCheckout,
    CsaPanel,
    ItemReviewCard,
    CartSummary,
    ShippingOptions,
    angularFilter,
    PromoBannerSideCol,
    OrderSummaryList,
    AkrisOrderSummaryList,
    PageLevelAlertMessing,
    PaymentCreditCardForm,
    PaymentCreditCardFrameForm,
    QuantityAdjustment,
    CoOpBanner,
    ReviewOrder,
    ThankYou,
    Payment
])
    .service('CartEvents', CartEvents)
    .service('CartService', CartService)
    .config(routing)
    .run(function ($rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
        if (next.name === 'logout' && current && current.name && !current.authenticate) {
            next.referrer = current.name;
        }
    });
})
    .name;
//# sourceMappingURL=index.js.map